import { render } from "./GiftRegister.vue?vue&type=template&id=39c9248a&scoped=true"
import script from "./GiftRegister.vue?vue&type=script&lang=js"
export * from "./GiftRegister.vue?vue&type=script&lang=js"

import "./GiftRegister.vue?vue&type=style&index=0&id=39c9248a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c9248a"]])

export default __exports__